export default __webpack_public_path__ + "static/media/download-new.6397ffc4.svg";